<template>
  <div class="ShowMoreLabel">
    <div v-if="value.length>contentLength"
         data-toggle="tooltip"
         size="sm"
         v-b-tooltip.hover.bottom="value"
         class="cursor-pointer">
      {{splitValue}}
    </div>

    <div v-else>
      {{value}}
    </div>

  </div>
</template>

<script>
export default {
  name: 'ShowMoreLabel',
  props: {
    value: {
      type: String,
      default: '-',
    },
  },
  data() {
    return {
      contentLength: 20,
    }
  },
  computed: {
    splitValue() {
      if (this.value.length > this.contentLength)
        return this.value.slice(0, this.contentLength) + '...'
      else return this.value
    },
  },
}
</script> 

<style lang="scss">
.tooltip.b-tooltip {
  opacity: 1;
}
.tooltip-inner {
  box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 19px;
  color: #464e5f;
}
.tooltip.b-tooltip .arrow {
  display: none;
}
</style>